import React from 'react';
import { getClientId } from 'utils';
import { InvestorProfileProvider } from 'components/InvestorProfileBase/Provider';
import { InvestorProfile } from './InvestorProfile';

import './InvestorProfile.css';

type Props = {
    dfsClientId: string;
    clientAge: number;
    clientName: string;
    title?: string;
    sessionStorageKey: string;
    onQuestionnaireUpdate?: (key: string, value: unknown) => void;
};

export const InvestorProfileWithProvider = ({
    dfsClientId, clientAge, clientName, title, sessionStorageKey, onQuestionnaireUpdate,
}: Props) => {
    const clientId = getClientId(dfsClientId);

    return (
        <InvestorProfileProvider options={{ clientId, sessionStorageKey }}>
            <InvestorProfile
                dfsClientId={dfsClientId}
                clientAge={clientAge}
                clientName={clientName}
                title={title}
                onQuestionnaireUpdate={onQuestionnaireUpdate}
            />
        </InvestorProfileProvider>
    );
};
